import React, { useContext, useEffect } from 'react';
import { Store } from '../Store';
import { ADMIN_URL } from '../api';

export default function ProtectedRoute({ children }) {
  const { state } = useContext(Store);
  const { userInfo } = state;
  
  useEffect(() => {
    if (!userInfo) {
      window.location.href = ADMIN_URL;
    }
  }, [userInfo]);
  
  return userInfo ? children : null;
}
